import { Component } from '@angular/core';
import { Professor } from '../../../../core/interfaces/professor';
import { ProfessorService } from '../../../../core/services/professor.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-teacher-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './teacher-profile.component.html',
  styleUrl: './teacher-profile.component.css',
})
export class TeacherProfileComponent {
  professorId!: string;
  professor!: Professor;
  isLoading: boolean = true;
  error: string | null = null;

  constructor(
    private professorService: ProfessorService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (!idParam) {
      console.error('Invalid professor ID in route.');
      this.isLoading = false;
      return;
    }

    this.professorId = idParam;

    this.professorService.getById(this.professorId).subscribe({
      next: ({ status, data, message }) => {
        if (status === 'SUCCESS') {
          this.professor = data;
        } else {
          console.warn('⚠️ API responded with failure:', message);
          this.error = message || 'Failed to load professor data.';
        }
        this.isLoading = false;
      },
      error: (err) => {
        console.error('❌ Error fetching professor data:', err);
        this.error = 'An error occurred while loading the professor data.';
        this.isLoading = false;
      },
    });
  }
}
